import React from 'react';
import { CheckIcon, LockIcon } from 'lucide-react';
import type { LoanScenarioRow } from '../types/commission';
import { formatBps, formatCurrency, formatPercent, formatSignedCurrency } from '../utils/format';
interface TierLadderTableProps {
  rows: LoanScenarioRow[];
}
export function TierLadderTable({
  rows
}: TierLadderTableProps) {
  return <div className="overflow-x-auto" data-id="element-171" data-mp="2bd5dwasfbnaa">
      <table className="w-full min-w-[720px] border-collapse text-sm" data-id="element-172" data-mp="26e2kjnlt35i5">
        <caption className="sr-only" data-id="element-173" data-mp="26bzho2zk1hw0">Payout for this loan at each tier of the plan</caption>
        <thead data-id="element-174" data-mp="22etogc3amvjf">
          <tr className="border-b border-slate-200 text-left text-xs font-semibold uppercase tracking-wide text-slate-500" data-id="element-175" data-mp="1xdmgabx8nuc8">
            <th scope="col" className="px-5 py-2.5" data-id="element-176" data-mp="1sf2r82ncm2fn">Tier</th>
            <th scope="col" className="px-5 py-2.5" data-id="element-177" data-mp="1sgnldr5r3jcz">Loans closed</th>
            <th scope="col" className="px-5 py-2.5 text-right" data-id="element-178" data-mp="3rqc88o41qtgz">Rate</th>
            <th scope="col" className="px-5 py-2.5 text-right" data-id="element-179" data-mp="3msarway09897">Loan pay</th>
            <th scope="col" className="px-5 py-2.5 text-right" data-id="element-180" data-mp="1h6t5yai80ngh">Unit bonus</th>
            <th scope="col" className="px-5 py-2.5 text-right" data-id="element-181" data-mp="1h8vzh4il0ypy">Overage share</th>
            <th scope="col" className="px-5 py-2.5 text-right" data-id="element-182" data-mp="1l9pqi6rbmtn2">Payout</th>
            <th scope="col" className="px-5 py-2.5 text-right" data-id="element-183" data-mp="179nayr6hkcaz">Status</th>
          </tr>
        </thead>
        <tbody data-id="element-184" data-mp="1c8rmvpksoo50">
          {rows.map(row => {
          const isCurrent = row.status === 'current';
          return <tr key={row.tier.id} className={`border-b border-slate-100 last:border-0 ${isCurrent ? 'bg-brand-50/70' : row.status === 'locked' ? 'text-slate-400' : ''}`} data-id="element-185" data-mp="1zy2m32mhyah1">
                <th scope="row" className={`px-5 py-3 text-left font-semibold ${isCurrent ? 'text-brand-800' : 'text-slate-700'}`} data-id="element-186" data-mp="1v5sqb5ypag6u">
                  {row.tier.name}
                </th>
                <td className="px-5 py-3 tabular-nums" data-id="element-187" data-mp="2xilrh9mkyj1l">
                  {row.tier.minUnits}
                  {row.tier.maxUnits === null ? '+' : `–${row.tier.maxUnits}`}
                </td>
                <td className="px-5 py-3 text-right tabular-nums" data-id="element-188" data-mp="2nkecgwbuqb28">
                  {formatBps(row.tier.basisPoints)}
                </td>
                <td className="px-5 py-3 text-right tabular-nums" data-id="element-189" data-mp="2jiayo11pmuds">{formatCurrency(row.basePay)}</td>
                <td className="px-5 py-3 text-right tabular-nums" data-id="element-190" data-mp="2ekrl73cu6lmw">
                  {formatCurrency(row.unitBonus)}
                </td>
                <td className="px-5 py-3 text-right tabular-nums" data-id="element-191" data-mp="29rgd6ywafyte">
                  {formatSignedCurrency(row.overageShare)}
                  <span className="ml-1 text-xs text-slate-400" data-id="element-192" data-mp="1zvlq9rl17hkt">
                    ({formatPercent(row.tier.overageSplit)})
                  </span>
                </td>
                <td className={`px-5 py-3 text-right font-semibold tabular-nums ${isCurrent ? 'text-brand-800' : ''}`} data-id="element-193" data-mp="1vvb9rkzm58rp">
                  {formatCurrency(row.total)}
                </td>
                <td className="px-5 py-3 text-right" data-id="element-194" data-mp="ba4pjv6z4dxc">
                  {isCurrent ? <span className="inline-flex items-center gap-1 rounded-full bg-brand-600 px-2.5 py-1 text-xs font-semibold text-white" data-id="element-195" data-mp="fe46ug02vgrr">
                      <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-196" data-mp="k9ruus2tq3vo" />
                      This loan
                    </span> : row.status === 'cleared' ? <span className="text-xs font-medium text-emerald-700" data-id="element-197" data-mp="3nt4f1pfsxuok">Cleared</span> : <span className="inline-flex items-center gap-1 text-xs font-medium text-slate-500" data-id="element-198" data-mp="3sq4j5ut3cnd1">
                      <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-199" data-mp="1f4eax9g2hqb" />
                      {row.unitsToReach} more loan{row.unitsToReach === 1 ? '' : 's'}
                    </span>}
                </td>
              </tr>;
        })}
        </tbody>
      </table>
    </div>;
}